module.exports = __webpack_public_path__ + "static/media/20.967c0075.png";